// Carrossel dos serviços com IA na home (books/_home_services).
//
// A trilha é uma rolagem lateral nativa com encaixe (CSS), então arrastar, trackpad e
// teclado já funcionam. Os botões das laterais só passam uma página de cards e somem
// quando não há mais nada daquele lado.
//
// No celular (um card por vez) o arrasto é controlado aqui: o card acompanha o dedo e, ao
// soltar, passa exatamente um card para o lado do gesto (basta SWIPE_MIN de arrasto), em vez de
// depender do encaixe nativo, que varia entre navegadores e às vezes pula ou volta.
//
// Passa sozinho um card a cada AUTOPLAY_MS (no fim, volta ao começo). Pausa enquanto a
// pessoa está usando (mouse em cima, foco dentro, toque) ou quando a seção está fora da
// tela / a aba escondida, e não roda com "reduzir movimento" ligado.

var AUTOPLAY_MS = 5000;
var SWIPE_MIN = 40;

function setup(carousel) {
  if (carousel.getAttribute('data-cda-svc-bound') === '1') return;
  carousel.setAttribute('data-cda-svc-bound', '1');

  var track = carousel.querySelector('[data-cda-svc-track]');
  var prev = carousel.querySelector('[data-cda-svc-prev]');
  var next = carousel.querySelector('[data-cda-svc-next]');
  if (!track || !prev || !next) return;

  // distância de um card (largura + espaço entre eles)
  function cardStep() {
    var card = track.children[0];
    if (!card) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  // uma página = quantos cards inteiros cabem na área visível
  function pageWidth() {
    var step = cardStep();
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return Math.max(1, Math.floor((track.clientWidth + gap) / step)) * step;
  }

  // bolinhas (celular): ficam fora do carrossel, logo abaixo dele
  var dots = carousel.parentNode.querySelectorAll('[data-cda-svc-dot]');

  function update() {
    var max = track.scrollWidth - track.clientWidth;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max - 2;

    var current = Math.round(track.scrollLeft / cardStep());
    if (track.scrollLeft >= max - 2) current = dots.length - 1; // no fim, a última
    Array.prototype.forEach.call(dots, function(dot, index) {
      dot.classList.toggle('is-active', index === current);
      if (index === current) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  Array.prototype.forEach.call(dots, function(dot) {
    dot.addEventListener('click', function() {
      track.scrollTo({ left: parseInt(dot.getAttribute('data-cda-svc-dot'), 10) * cardStep() });
      restart();
    });
  });

  prev.addEventListener('click', function() { track.scrollBy({ left: -pageWidth() }); restart(); });
  next.addEventListener('click', function() { track.scrollBy({ left: pageWidth() }); restart(); });

  // Arrasto um por um no celular
  var mobile = window.matchMedia('(max-width: 575.98px)');
  var drag = null;

  function goTo(index) {
    var last = track.children.length - 1;
    index = Math.max(0, Math.min(last, index));
    var left = Math.min(index * cardStep(), track.scrollWidth - track.clientWidth);
    track.scrollTo({ left: left, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    // o encaixe volta só depois que a animação termina, para não puxar o card no meio do caminho
    var restore = function() {
      track.removeEventListener('scrollend', restore);
      clearTimeout(restoreTimer);
      if (!drag) track.style.scrollSnapType = '';
    };
    var restoreTimer = setTimeout(restore, 600);
    track.addEventListener('scrollend', restore);
  }

  track.addEventListener('touchstart', function(event) {
    if (!mobile.matches || event.touches.length !== 1) return;
    var touch = event.touches[0];
    drag = {
      x: touch.clientX, y: touch.clientY, axis: null, dx: 0,
      left: track.scrollLeft, index: Math.round(track.scrollLeft / cardStep())
    };
  }, { passive: true });

  track.addEventListener('touchmove', function(event) {
    if (!drag) return;
    var touch = event.touches[0];
    var dx = touch.clientX - drag.x;
    var dy = touch.clientY - drag.y;
    if (!drag.axis) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (drag.axis === 'x') {
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
      }
    }
    if (drag.axis !== 'x') return;
    event.preventDefault();
    drag.dx = dx;
    track.scrollLeft = drag.left - dx;
  }, { passive: false });

  function endDrag() {
    if (!drag) return;
    var current = drag;
    drag = null;
    if (current.axis !== 'x') return;
    track.style.scrollBehavior = '';
    var target = current.index;
    if (current.dx <= -SWIPE_MIN) target += 1;
    else if (current.dx >= SWIPE_MIN) target -= 1;
    goTo(target);
  }

  track.addEventListener('touchend', endDrag, { passive: true });
  track.addEventListener('touchcancel', endDrag, { passive: true });

  var frame = null;
  track.addEventListener('scroll', function() {
    if (frame) return;
    frame = requestAnimationFrame(function() { frame = null; update(); });
  }, { passive: true });
  window.addEventListener('resize', update);
  update();

  // Passagem automática
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var paused = { hover: false, focus: false, touch: false, offscreen: true };
  var timer = null;

  function canPlay() {
    if (reducedMotion.matches || document.hidden) return false;
    if (track.scrollWidth - track.clientWidth <= 2) return false; // cabe tudo: nada a passar
    return !paused.hover && !paused.focus && !paused.touch && !paused.offscreen;
  }

  function tick() {
    if (!carousel.isConnected) return stop(); // saiu da página (turbolinks)
    if (!canPlay()) return;
    var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    if (atEnd) track.scrollTo({ left: 0 });
    else track.scrollBy({ left: cardStep() });
  }

  function stop() {
    clearInterval(timer);
    timer = null;
  }

  // qualquer navegação manual reinicia a contagem, para não passar logo em seguida
  function restart() {
    stop();
    timer = setInterval(tick, AUTOPLAY_MS);
  }

  function setPaused(reason, value) {
    paused[reason] = value;
    if (!value) restart();
  }

  carousel.addEventListener('mouseenter', function() { setPaused('hover', true); });
  carousel.addEventListener('mouseleave', function() { setPaused('hover', false); });
  carousel.addEventListener('focusin', function() { setPaused('focus', true); });
  carousel.addEventListener('focusout', function(event) {
    if (!carousel.contains(event.relatedTarget)) setPaused('focus', false);
  });
  // no toque, a pessoa pode estar lendo o card que arrastou: espera um pouco antes de voltar
  var touchTimer = null;
  track.addEventListener('touchstart', function() { clearTimeout(touchTimer); setPaused('touch', true); }, { passive: true });
  track.addEventListener('touchend', function() {
    touchTimer = setTimeout(function() { setPaused('touch', false); }, AUTOPLAY_MS);
  }, { passive: true });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(entries) {
      setPaused('offscreen', !entries[0].isIntersecting);
    }, { threshold: 0.35 }).observe(track);
  } else {
    setPaused('offscreen', false);
  }

  restart();
}

// Rede neural do fundo, sempre viva: cada nó flutua devagar em volta do ponto dele (ritmo e
// direção próprios), com as ligações e os pulsos acompanhando. Com mouse, os nós perto do
// cursor são puxados de leve até ele e o cursor vira um nó ligado aos vizinhos mais próximos;
// ao sair, voltam com uma mola. Só anima com a seção na tela e a aba visível, e fica parada
// com "reduzir movimento".
var NET_DRIFT = 14;       // quanto um nó flutua em volta do ponto, em unidades do viewBox
var NET_RADIUS = 190;     // alcance do cursor
var NET_PULL = 26;        // quanto um nó colado no cursor anda até ele
var NET_PROBES = 5;       // ligações do cursor com os nós mais próximos
var SVG_NS = 'http://www.w3.org/2000/svg';

function setupNet(section) {
  var svg = section.querySelector('.cda-svc__net');
  if (!svg || svg.getAttribute('data-cda-svc-net-bound') === '1') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  svg.setAttribute('data-cda-svc-net-bound', '1');
  var interactive = window.matchMedia('(hover: hover) and (pointer: fine)').matches && !!svg.getScreenCTM;

  // monta o grafo a partir do SVG já desenhado no servidor (os nós são achados pela coordenada)
  var nodes = [];
  var byPoint = {};
  Array.prototype.forEach.call(svg.querySelectorAll('.cda-svc__net-nodes circle'), function(el, index) {
    var x = +el.getAttribute('cx');
    var y = +el.getAttribute('cy');
    byPoint[x + ' ' + y] = nodes.length;
    // ritmo e fase "aleatórios" mas fixos por nó (a rede é sempre a mesma)
    var seed = Math.sin(index * 12.9898 + x * 0.013 + y * 0.007) * 43758.5453;
    var r = seed - Math.floor(seed);
    nodes.push({
      el: el, x0: x, y0: y, x: x, y: y, px: 0, py: 0,
      fx: 0.00036 + r * 0.00028, fy: 0.0003 + (1 - r) * 0.0003,
      phx: r * 6.283, phy: (r * 7.1) % 6.283,
      amp: NET_DRIFT * (0.6 + r * 0.6)
    });
  });

  var linksEl = svg.querySelector('.cda-svc__net-links');
  var edges = [];
  linksEl.getAttribute('d').replace(/M(-?[\d.]+) (-?[\d.]+)L(-?[\d.]+) (-?[\d.]+)/g, function(_, x1, y1, x2, y2) {
    var a = byPoint[+x1 + ' ' + +y1];
    var b = byPoint[+x2 + ' ' + +y2];
    if (a !== undefined && b !== undefined) edges.push([a, b]);
  });

  var hubs = Array.prototype.map.call(svg.querySelectorAll('.cda-svc__net-hubs circle'), function(el) {
    return { el: el, node: byPoint[+el.getAttribute('cx') + ' ' + +el.getAttribute('cy')] };
  }).filter(function(hub) { return hub.node !== undefined; });

  var pulses = Array.prototype.map.call(svg.querySelectorAll('.cda-svc__net-pulses path'), function(el) {
    var ids = (el.getAttribute('d').match(/-?[\d.]+ -?[\d.]+/g) || []).map(function(point) {
      var xy = point.split(' ');
      return byPoint[+xy[0] + ' ' + +xy[1]];
    });
    return { el: el, ids: ids };
  }).filter(function(pulse) { return pulse.ids.every(function(id) { return id !== undefined; }); });

  // o "nó" do cursor e as ligações dele
  var probeLines = [];
  var probeDot = null;
  if (interactive) {
    var probe = document.createElementNS(SVG_NS, 'g');
    probe.setAttribute('class', 'cda-svc__net-probe');
    for (var i = 0; i < NET_PROBES; i++) {
      var line = document.createElementNS(SVG_NS, 'line');
      probe.appendChild(line);
      probeLines.push(line);
    }
    probeDot = document.createElementNS(SVG_NS, 'circle');
    probeDot.setAttribute('r', '3.5');
    probe.appendChild(probeDot);
    svg.appendChild(probe);
  }

  var cursor = null;   // posição do mouse no viewBox (null = fora da seção)
  var strength = 0;    // 0..1, o cursor entra e sai suave
  var visible = false;
  var frame = null;

  function fixed(n) { return n.toFixed(1); }

  function step(time) {
    frame = null;
    if (!visible || document.hidden || !svg.isConnected) return;
    strength += ((cursor ? 1 : 0) - strength) * 0.12;

    nodes.forEach(function(node) {
      // flutuação: uma pequena órbita em volta do ponto original
      var bx = node.x0 + Math.sin(time * node.fx + node.phx) * node.amp;
      var by = node.y0 + Math.cos(time * node.fy + node.phy) * node.amp * 0.8;

      // atração do cursor (suavizada em px/py)
      var tpx = 0;
      var tpy = 0;
      if (cursor) {
        var dx = cursor.x - bx;
        var dy = cursor.y - by;
        var dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < NET_RADIUS && dist > 0.01) {
          var pull = Math.min(Math.pow(1 - dist / NET_RADIUS, 2) * NET_PULL * strength, dist);
          tpx = dx / dist * pull;
          tpy = dy / dist * pull;
        }
      }
      node.px += (tpx - node.px) * 0.14;
      node.py += (tpy - node.py) * 0.14;
      node.x = bx + node.px;
      node.y = by + node.py;
      node.el.setAttribute('cx', fixed(node.x));
      node.el.setAttribute('cy', fixed(node.y));
    });

    var d = '';
    edges.forEach(function(edge) {
      var a = nodes[edge[0]];
      var b = nodes[edge[1]];
      d += 'M' + fixed(a.x) + ' ' + fixed(a.y) + 'L' + fixed(b.x) + ' ' + fixed(b.y);
    });
    linksEl.setAttribute('d', d);

    hubs.forEach(function(hub) {
      hub.el.setAttribute('cx', fixed(nodes[hub.node].x));
      hub.el.setAttribute('cy', fixed(nodes[hub.node].y));
    });

    pulses.forEach(function(pulse) {
      pulse.el.setAttribute('d', 'M' + pulse.ids.map(function(id) {
        return fixed(nodes[id].x) + ' ' + fixed(nodes[id].y);
      }).join('L'));
    });

    if (interactive) drawProbe();
    schedule();
  }

  // cursor ligado aos nós mais próximos, mais forte quanto mais perto
  function drawProbe() {
    var near = cursor ? nodes.map(function(node) {
      var dx = node.x - cursor.x;
      var dy = node.y - cursor.y;
      return { node: node, dist: Math.sqrt(dx * dx + dy * dy) };
    }).filter(function(item) { return item.dist < NET_RADIUS; })
      .sort(function(a, b) { return a.dist - b.dist; }) : [];

    probeLines.forEach(function(line, index) {
      var item = near[index];
      if (!item) { line.style.opacity = '0'; return; }
      line.setAttribute('x1', fixed(cursor.x));
      line.setAttribute('y1', fixed(cursor.y));
      line.setAttribute('x2', fixed(item.node.x));
      line.setAttribute('y2', fixed(item.node.y));
      line.style.opacity = ((1 - item.dist / NET_RADIUS) * 0.55 * strength).toFixed(3);
    });
    if (cursor) {
      probeDot.setAttribute('cx', fixed(cursor.x));
      probeDot.setAttribute('cy', fixed(cursor.y));
    }
    probeDot.style.opacity = (near.length ? strength : 0).toFixed(3);
  }

  function schedule() {
    if (!frame && visible && !document.hidden) frame = requestAnimationFrame(step);
  }

  if (interactive) {
    section.addEventListener('pointermove', function(event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      var point = svg.createSVGPoint();
      point.x = event.clientX;
      point.y = event.clientY;
      cursor = point.matrixTransform(svg.getScreenCTM().inverse());
    });
    section.addEventListener('pointerleave', function() { cursor = null; });
  }

  // só anima com a seção na tela e a aba visível
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(entries) {
      visible = entries[0].isIntersecting;
      schedule();
    }).observe(section);
  } else {
    visible = true;
  }
  document.addEventListener('visibilitychange', schedule);
  schedule();
}

document.addEventListener('turbolinks:load', function() {
  Array.prototype.forEach.call(document.querySelectorAll('[data-cda-svc-carousel]'), setup);
  Array.prototype.forEach.call(document.querySelectorAll('.cda-svc'), setupNet);
});
